import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskDescription from '../components/TaskDescription'
import TaskBreadcrumb from '../components/TaskBreadcrumb'

export default function N25_09_15() {
  return (
    <NoteContainer date={'15/09/2025'} version="20.4.2">
      <VStack w="full">
        <ModuleContainer moduleName="SERVICES_LETTER">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção do erro da automação inexistente</TaskTitle>
                <TaskBreadcrumb>Serviços/Perfil do serviço/Automações</TaskBreadcrumb>
                <TaskDescription>
                  Corrigido erro que quebrava a página quando o tipo da automação não existe
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="PROCESSES_AND_DOCUMENTS">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle>Automação na consulta por QR Code</TaskTitle>
                <TaskBreadcrumb>Documentos/ Consulta por QR Code</TaskBreadcrumb>
                <TaskDescription>
                  Na página de acesso pelo QR Code, ao clicar no botão para consultar, agora preenche o código de
                  verificação do documento de forma automática
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="REGULATION">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção quando a resposta é nula</TaskTitle>
                <TaskBreadcrumb>Painel da Regulação/ Detalhes</TaskBreadcrumb>
                <TaskDescription>
                  Corrigido o erro que quebrava a página se a resposta de questões do tipo UPLOAD vierem nulas
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Tratamento em URL</TaskTitle>
                <TaskBreadcrumb>Geral</TaskBreadcrumb>
                <TaskDescription>
                  Tratando redirecionamento da antiga url &quot;/regulacao/painel-de-solicitacao&quot; para a nova url
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
